// removed by extract-text-webpack-plugin
module.exports = {"infoBar":"_1lCH-MBfZj1fnt4rCagS0w","time":"vX6YJOTmo08GoFXLDXEuE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoBar/InfoBar.scss
// module id = 1057
// module chunks = 0